import React from 'react'

import { Table } from 'antd'

import {
  MigrationQueueFilter,
  MigrationStatus,
  PagedMigrationQueue,
} from 'core/application/csiDashboard/migration/getMigrationQueue'

import { formatDateTimeAMPM } from 'common/dateFormatters'

interface MigrationQueueResultsTableProps {
  onTableChange: (value: any) => void
  onCompanySelect: (value: any) => void
  loadingMigrationQueueResults: boolean
  migrationQueueResults: PagedMigrationQueue
}

const MigrationQueueResultsTable: React.FC<MigrationQueueResultsTableProps> = ({
  onTableChange,
  onCompanySelect,
  loadingMigrationQueueResults,
  migrationQueueResults,
}) => {
  const columns = [
    {
      title: 'Company Id',
      dataIndex: 'companyId',
      key: 'companyId',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <a
            onClick={() => {
              onCompanySelect(record.companyId)
            }}
          >
            {record.companyId}
          </a>
        </span>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      render: (text: string, record: any) => <span>{getMigrationStatus(record.status)}</span>,
    },
    {
      title: 'Migration Date',
      dataIndex: 'migrationDate',
      key: 'migrationDate',
      sorter: false,
      render: (text: string, record: any) => (
        <span>{record.migrationDate && formatDateTimeAMPM(record.migrationDate)}</span>
      ),
    },
  ]

  const onMigrationQueueResultsTableChange = (pagination: any, filters: any, sorter: any) => {
    const obj = {
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: sorter.field,
      orderDescending: sorter.order === 'descend',
    }
    onTableChange(obj)
  }

  const getMigrationStatus = (status: MigrationStatus) => {
    var retVal = ''
    switch (status) {
      case MigrationStatus.Started:
        retVal = 'Started'
        break
      case MigrationStatus.Queued:
        retVal = 'Queued'
        break
      case MigrationStatus.Failed:
        retVal = 'Failed'
        break
      case MigrationStatus.Completed:
        retVal = 'Completed'
        break
    }

    return retVal
  }

  return (
    <Table
      dataSource={migrationQueueResults.items}
      loading={loadingMigrationQueueResults}
      onChange={onMigrationQueueResultsTableChange}
      columns={columns}
      pagination={{
        total: migrationQueueResults.totalItemCount,
        pageSize: migrationQueueResults.pageSize,
        current: migrationQueueResults.pageNumber,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200'],
      }}
    ></Table>
  )
}

export default MigrationQueueResultsTable
